import Intro from "../casestudy/Intro";
import SEO from "../Component/SEO";
import Gfooter from "../Component/Gfooter";
import Clients from "./Clients";
import Heading from "./Heading";

export default function Clientele() {
  return (
    <div>
      <div className="clienttop">
        <SEO
          title="Our Clients & Architectural Projects | NLF Solutions"
          description="Discover NLF Solutions' clients and completed projects showcasing expertise in metal ceilings, facades, roofing, furniture and acoustic solutions across India."
          canonical="https://nlfs.in/clientele"
          keywords="NLF Clientele, NLF clients, NLF trusted clients, NLF project clients, NLF client portfolio, Architectural project clients, companies that worked with NLF Solutions, NLF Solutions project clients, NLF architectural project portfolio"
        />
        <h1 className="seo-h1">Our Clientele</h1>
        <Heading />
      </div>
      <Clients />
      <Gfooter />
    </div>

  )
}